export default __webpack_public_path__ + "static/media/lap.1c2cbf07.png";